import {
  CORE_LOAD_USERS_REQUEST,
  CORE_LOAD_USERS_SUCCESS
} from '../../types'

const initialState = []
export default {
  users: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_USERS_REQUEST:
        return initialState
      case CORE_LOAD_USERS_SUCCESS:
        if (action.payload[0]) {
          const payload = action.payload[0]
          let user = []
          for (let i = 0; i < payload.length; i++) {
            user.push({ value: payload[i]._id, key: i, text: payload[i].fullName })
          }
          return user
        } else
          return [{ value: 0, key: 0, text: 0 }]

      default:
        return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/front/features/users/reducer.js